<template>
  <modal
    name="highlight-legend"
    :adaptive="true"
    :classes="['v--modal', 'highlight-legend']"
    height="auto"
    :max-width="370"
  >
    <div class="modal-content">
      <h2>Highlight Answer Legend</h2>

      <h3>
        <span class="highlight-checkmark-correct"></span><span class="highlight-green">Correct answer choice</span>
      </h3>
      <h3>
        <span class="highlight-checkmark-incorrect"></span><span class="highlight-red">Incorrect answer choice</span>
      </h3>
      <h3>
        <span class="highlight-checkmark-correct"></span><span>Correct choice not selected</span>
      </h3>
    </div>
    <div
      class="close"
      @click="dismiss"
    ></div>
    <button
      class="btn-confirm"
      @click="dismiss"
    >
      <span>OKAY</span>
    </button>
  </modal>
</template>

<script>
export default {
  computed: {
  },
  methods: {
    dismiss() {
      this.$modal.hide('highlight-legend');
    },
  },
};
</script>


<style lang="scss">
.btn-confirm {
  height: rem-calc(48);
  width: 100%;
  margin: 1rem 0;
  border-radius: rem-calc(24);
  background-color: #00B46D;
  span {
    color: #ffffff;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
  }
}
.v--modal-overlay[data-modal="highlight-legend"] {
  background: rgba(0, 0, 0, .90);

  .v--modal {
    background: white;
    border-radius: 4px;
    box-shadow: none;
    padding: rem-calc(28);
  }
}

.wrapper {
  position: relative;
  display: inline-block;
}

.highlight-legend .close:before {
  content: '✕';
}
.close {
  position: absolute;
  top: 1px;
  right: 5px;
  cursor: pointer;
  font-size: 30px;
}

.highlight-checkmark-correct {
      display:inline-block;
      width: 22px;
      height:22px;
      background: #66bb6a;
      border-radius:50%;
      -ms-transform: rotate(45deg); /* IE 9 */
      -webkit-transform: rotate(45deg); /* Chrome, Safari, Opera */
      transform: rotate(45deg) translate(4px, 4px);
      margin-right: 5px;
  }

  .highlight-checkmark-correct:before{
      content:"";
      position: absolute;
      width: 3px;
      height: 9px;
      background-color: #fff;
      left: 11px;
      top: 6px;
  }

  .highlight-checkmark-correct:after{
      content: "";
      position: absolute;
      width: 3px;
      height: 3px;
      background-color: #fff;
      left: 8px;
      top: 12px;
  }

  .highlight-checkmark-incorrect::before {
    content: "X";
  }
  .highlight-checkmark-incorrect {
    margin-right: 5px;
    display: inline-block;
    width: 22px;
    line-height: 22px;
    border-radius: 50%;
    font-size: 14px;
    color: white;
    background-color: red;
    font-weight: bold;
    font-family: verdana;
    text-align: center;
  }

  .highlight-green {
    background-color: #D9F4E9;
    padding: 0 4px 0 4px;
  }

  .highlight-red {
    background-color: #FAE1DC;
    padding: 0 4px 0 4px;
  }

.higlight-legend {
  $success-green: #00b46d;
  display: flex;
  align-items: center;
  justify-content: center;

  .modal-content {
    max-width: rem-calc(376);
    text-align: center;
    line-height: 1.5;

    h3 {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
    }
    h2 {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
    }
    .text {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
    }
  }

}
</style>
